import React from "react";
import './ourStory.scss';

const OurStory = () => {


    return(
        <div className='wrapper-ourStory row w-100'>
           <div className='wrapper-text p-5'>
           <div class="header-ourStory" >
                    <h2 >Povestea noastră</h2>
                    <div></div>
                </div>
           <div class="pb-text col-12" >
                    <p className='text-muted'>Născută din dorința unor specialiști de a face diferența pe piața serviciilor psihologice,
                        <strong>Asociația Terapeutică de Intervenție, Psihoterapie Individuală și Comportamentală
                             - A.T.I.P.I.C</strong> propune o abordare integrată, multidisciplinară și din perspective
                        noi ale “științei sufletului și a minții”.</p>
                    <p className='text-muted'>Asociația noastră se axează pe terapia, recuperarea și maximizarea potențialului copiilor cu TSA
                        și întârziere în dezvoltare, precum și pe oferirea sprijinului psiho-emoțional acordat
                        familiilor acestora.</p>
                    <p className='text-muted'>Terapia personalizată, adaptată nevoilor individuale, precum și serviciile de cea mai buna
                        calitate oferite de un personal specializat și dedicat întru totul micuților,
                        ne ajută să ne mândrim cu rezultate de excepție obținute cu ajutorul terapiei ABA, VB, art
                        terapiei și logopediei.</p>
                    <p className='text-muted'>Rezultatele obținute variază de la corectarea limbajului, stabilitatea comportamentului și
                        reducerea stereotipiilor, pâna la adaptarea și inserția socială corespunzatoare vârstei.</p>
                    <p className='text-muted'>Pentru noi, provocarea de zi cu zi este să aducem informații valoroase, să oferim suport și
                        consiliere, să inspirăm, cu pasiune și devotament, cu respect pentru profesie și dragoste pentru
                        oameni.</p>
                </div>
                
           </div>
        </div>
    )
}


export default OurStory